import {FlexPage} from '@hconnect/common/components'
import {sideCardSize, tableWithOutSideCard, tableWithSideCard} from '@hconnect/common/consts'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {Grid} from '@mui/material'

type LayoutProps = {
  templatesTableSlot: React.ReactNode
  templateDetailsSlot?: React.ReactNode
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
}

export const ChecklistsTemplatesDesktopLayout = ({
  templatesTableSlot,
  templateDetailsSlot,
  titleSlot,
  aboveTitleSlot
}: LayoutProps) => {
  const isTemplatePreviewDisplayed = !!templateDetailsSlot

  return (
    <FlexPage
      title={titleSlot}
      aboveTitle={aboveTitleSlot}
      nameHeaderSx={{mt: aboveTitleSlot ? 0 : undefined}}
    >
      <Grid container flexGrow={1} overflow={'hidden'} spacing={2}>
        <Grid
          item
          height={'100%'}
          {...(isTemplatePreviewDisplayed ? {...tableWithSideCard, sm: 6} : tableWithOutSideCard)}
        >
          <CardBox
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%'
            }}
          >
            {templatesTableSlot}
          </CardBox>
        </Grid>
        {isTemplatePreviewDisplayed && (
          <Grid
            item
            {...sideCardSize}
            sm={6}
            sx={{
              height: '100%',
              overflow: 'hidden'
            }}
          >
            {templateDetailsSlot}
          </Grid>
        )}
      </Grid>
    </FlexPage>
  )
}
